module.exports = __webpack_public_path__ + "media/assets/images/events/20210922/evento_settembre_2021-7e4500f1a7d0c82cd6500746cfdba07d.jpg";